module.exports = __webpack_public_path__ + "img/gradient-10.41220345.png";